export default __webpack_public_path__ + "static/media/logo-office365.ec6723e4.svg";